module.exports = __webpack_public_path__ + "img/profile.8f6ff48c.svg";